import { FC, useCallback, useState } from 'react';

import useToggle from '@hooks/useToggle';
import { IAdminProgramCodeDrugClass } from '@interfaces/adminProgramCodes';

import FormDrugClassesControl from './FormDrugClassesControl/FormDrugClassesControl';
import FormDrugClassesModal from './FormDrugClassesModal/FormDrugClassesModal';
import { IFormDrugClassesProps } from './FormDrugClasses.interface';

const FormDrugClasses: FC<IFormDrugClassesProps> = ({
  className,
  input: { value = [], onChange },
}) => {
  const [isModalOpen, handleOpenModal, handleCloseModal] = useToggle();
  const [currentItem, setCurrentItem] = useState<IAdminProgramCodeDrugClass>();

  const handleEdit = useCallback(
    (target: IAdminProgramCodeDrugClass) => {
      setCurrentItem(target);
      handleOpenModal();
    },
    [handleOpenModal],
  );

  const handleCreateNew = useCallback(
    (item: IAdminProgramCodeDrugClass) => onChange([...value, item]),
    [value, onChange],
  );

  const handleSaveChanges = useCallback(
    (target: IAdminProgramCodeDrugClass) =>
      onChange(value.map(item => (item === currentItem ? target : item))),
    [value, currentItem, onChange],
  );

  const handleDelete = useCallback(
    (target: IAdminProgramCodeDrugClass) => onChange(value.filter(item => item !== target)),
    [value, onChange],
  );

  const handleClear = useCallback(() => setCurrentItem(undefined), []);

  return (
    <>
      <FormDrugClassesControl
        className={className}
        value={value}
        onCreate={handleOpenModal}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <FormDrugClassesModal
        open={isModalOpen}
        currentItem={currentItem}
        onClose={handleCloseModal}
        onExited={handleClear}
        onApply={currentItem ? handleSaveChanges : handleCreateNew}
      />
    </>
  );
};

export default FormDrugClasses;
